// components/Footer.js - Footer component
import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
} from "@mui/material";
import {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  Email,
  Phone,
  LocationOn,
} from "@mui/icons-material";

import Momentsia_logo from "../image/Momentsia _logo.png";
const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
        pt: 8,
        pb: 6,
        mt: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  component="img"
                  src={Momentsia_logo}
                  alt="Elevate Events Logo"
                  sx={{ height: 40, mr: 1 }}
                />
              </Box>
            </Box>
            <Typography variant="body2" color="text.secondary" paragraph>
              We design the flow of the celebration before the visuals — how
              guests arrive, settle, interact and remember the evening.
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <IconButton
                component="a"
                href="https://www.facebook.com/share/16jRnLsBU4/"
                target="_blank"
                aria-label="Facebook"
                sx={{
                  bgcolor: "primary.light",
                  color: "white",
                  "&:hover": {
                    bgcolor: "primary.light",
                    color: "white",
                  },
                }}
              >
                <Facebook />
              </IconButton>
              {/* <IconButton
                aria-label="Twitter"
                sx={{ bgcolor: "info.main", color: "white",  "&:hover": {
                    bgcolor: "primary.light",
                    color: "white",
                  }, }}
              >
                <Twitter />
              </IconButton> */}
              <IconButton
                component="a"
                href="https://www.instagram.com/momentsia_events?igsh=cjc4YXA2aDQ2cWQ3"
                target="_blank"
                aria-label="Instagram"
                sx={{
                  bgcolor: "error.light",
                  color: "white",
                  "&:hover": {
                    bgcolor: "primary.light",
                    color: "white",
                  },
                }}
              >
                <Instagram />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.linkedin.com/company/momentsiaevents/"
                target="_blank"
                aria-label="LinkedIn"
                sx={{
                  bgcolor: "info.dark",
                  color: "white",
                  "&:hover": {
                    bgcolor: "primary.light",
                    color: "white",
                  },
                }}
              >
                <LinkedIn />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            {/* <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Newsletter
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Subscribe to receive updates on event planning tips, special offers, and industry trends.
            </Typography>
            <Box component="form" sx={{ display: 'flex' }}>
              <input
                type="email"
                placeholder="Your email"
                style={{
                  flexGrow: 1,
                  padding: '10px 16px',
                  border: '1px solid #ccc',
                  borderRight: 'none',
                  borderRadius: '4px 0 0 4px',
                  fontSize: '14px',
                }}
              />
              <button
                type="submit"
                style={{
                  background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
                  color: 'white',
                  border: 'none',
                  padding: '0 20px',
                  borderRadius: '0 4px 4px 0',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
              >
                Subscribe
              </button>
            </Box> */}
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Services
            </Typography>
            <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
              {[
                "Event Planning",
                "Wedding Management",
                "Corporate Events",
                "Venue Selection",
                "Catering",
                "Entertainment",
              ].map((item) => (
                <li key={item} style={{ marginBottom: 8 }}>
                  <Link
                    href="#"
                    color="text.secondary"
                    underline="hover"
                    sx={{ "&:hover": { color: "primary.main" } }}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Contact Info
            </Typography>
            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
              <LocationOn sx={{ mr: 2, color: "primary.main", mt: 0.5 }} />
              <Typography variant="body2" color="text.secondary">
                Momentsia 703, 7th Floor
                <br />
                NH12, Action Area IIE, Newtown West Bengal 700161
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Phone sx={{ mr: 2, color: "primary.main" }} />
              <Typography variant="body2" color="text.secondary">
                +91 85848 26222
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Email sx={{ mr: 2, color: "primary.main" }} />
              <Typography variant="body2" color="text.secondary">
                info@momentsia.com
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Elevate Events. All rights reserved.
          </Typography>
          <Box sx={{ display: "flex", gap: 3, mt: { xs: 2, sm: 0 } }}>
            {/* <Link
              href="#"
              color="text.secondary"
              underline="hover"
              variant="body2"
            >
              Privacy Policy
            </Link>
            <Link
              href="#"
              color="text.secondary"
              underline="hover"
              variant="body2"
            >
              Terms of Service
            </Link>
            <Link
              href="#"
              color="text.secondary"
              underline="hover"
              variant="body2"
            >
              Cookie Policy
            </Link> */}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
